var _path, _rect, _ellipse, _circle, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateCanceledOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5585 44.8223C35.2751 45.5813 30.8897 57.5947 31.379 64.8054H66.6551C67.5207 58.0164 63.6722 46.024 49.5585 44.8223Z",
    fill: "url(#paint0_linear_684_19681)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.1831,
    y: 63.4277,
    width: 39.6072,
    height: 3.79312,
    rx: 1.89656,
    fill: "url(#paint1_linear_684_19681)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.7898,
    cy: 44.824,
    rx: 2.55837,
    ry: 2.04368,
    fill: "#DDDEDD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9963,
    cy: 14.301,
    r: 6.30095,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7498 40.3962C38.4588 40.3962 44.7082 34.1468 44.7082 26.4378C44.7082 18.7289 38.4588 12.4795 30.7498 12.4795C23.0409 12.4795 16.7915 18.7289 16.7915 26.4378C16.7915 34.1468 23.0409 40.3962 30.7498 40.3962Z",
    fill: "url(#paint2_linear_684_19681)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9375 22.25L26.5625 30.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 22.25L34.9375 30.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_684_19681",
    x1: 49.119,
    y1: 44.8223,
    x2: 49.119,
    y2: 62.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_684_19681",
    x1: 48.9867,
    y1: 63.4277,
    x2: 48.9867,
    y2: 67.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_684_19681",
    x1: 14,
    y1: 26.626,
    x2: 63.5,
    y2: 26.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateCanceledOn);
export default __webpack_public_path__ + "static/media/state_canceled_on.77aca03394ed8605ceb24b618b6faea9.svg";
export { ForwardRef as ReactComponent };